import { openNavDrawer } from './nav-drawer.js'

const elSkipToNav = document.querySelector('[data-skip-nav]')
const mq = window.matchMedia('(max-width: 1024px)')

if (elSkipToNav && mq.matches) {
    elSkipToNav.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        openNavDrawer()
    })
}
